import { describeError, type ErrorContext } from "../auth/error-message";

/** What failed, what to do, and the request ID to quote (ADR-0016 §2.5). */
export function ErrorNotice({ error, context }: { error: unknown; context?: ErrorContext }) {
  const { message, reference } = describeError(error, context);
  return (
    <div className="error" role="alert">
      <span>{message}</span>
      <span className="ref">{reference}</span>
    </div>
  );
}
